import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/services/hip'

const Dx: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション'}
        image={'https://www.i3design.jp/img/ogp_logo.png'}
        url={'https://www.i3design.jp/services/hip/'}
        title="組織開発・人材育成 | サービス | i3DESIGN アイスリーデザイン"
        description="イノベーション思考を実践してDXマインドを形成するワークショップ「ヒューマンイノベーションプログラム」を提供しています。"
      />
      <Template />
    </>
  )
}

export default Dx
